import { Typedocinfo } from './types/Typeschild_id';
import Image from 'next/image';

export default function DetailCom(props: Typedocinfo) {
    const { clincinfo, docinfo, time } = props;

    return (
        <div className="p-4 bg-white border-[#e4e4e7] border-solid rounded-2xl">
            <div className="flex items-center gap-3">
                <Image
                    src={
                        docinfo.doctor_image
                            ? process.env.NEXT_PUBLIC_STATIC_URL +
                              docinfo.doctor_image
                            : ''
                    }
                    alt={docinfo.name}
                    height={1000}
                    width={1000}
                    className="size-[64px] md:!size-[100px] rounded-full"
                />
                <div>
                    <h1 className="text-sm font-semibold text-gray-900 md:text-base">
                        {docinfo.name}
                    </h1>
                    <p className="pt-2 text-xs font-regular text-gray-400 md:text-sm">
                        {docinfo.mainSpecialty?.name
                            ? docinfo.mainSpecialty.name
                            : ''}
                    </p>
                </div>
            </div>
            <hr className="border-dashed my-4" />

            <div className="space-y-4">
                <div className="text-xs md:!text-sm flex justify-between">
                    <p className="font-medium text-gray-500">نوع نوبت: </p>
                    <p className="font-semibold">حضوری</p>
                </div>

                <div className="text-xs md:!text-sm flex justify-between">
                    <p className="font-medium text-gray-500">مکان نوبت: </p>
                    <p className="font-semibold">{clincinfo?.name}</p>
                </div>

                <div className="text-xs md:!text-sm gap-2 flex justify-between">
                    <p className="font-medium text-gray-500">زمان نوبت: </p>
                    <p className="text-xs md:!text-sm font-semibold">
                        {time.time}
                    </p>
                </div>
                <div className="text-xs md:!text-sm gap-2 flex justify-between">
                    <p className="font-medium text-gray-500">تاریخ نوبت: </p>
                    <p className="text-xs md:!text-sm font-semibold">
                        {time.jdate}
                    </p>
                </div>

                <div className="text-xs md:!text-sm gap-2 flex justify-between">
                    <p className="font-medium text-gray-500">آدرس:</p>
                    <h2 className="max-w-[60%] font-semibold text-justify">
                        {' '}
                        {clincinfo?.address ?? docinfo.address}
                    </h2>
                </div>
            </div>
        </div>
    );
}
